// Custom components
import React from "react";
import { Controller } from "react-hook-form";

function InputField(props) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    value,
    onChange,
    control,
    name,
    rules,
    className = "",
    ...rest
  } = props;

  const renderInput = ({ field = {}, error } = {}) => {
    const inputId = id || name;
    const inputState = error ? "error" : state;

    return (
      <div className={`${extra}`}>
        {label && (
          <label
            htmlFor={inputId}
            className={`text-sm text-navy-700 dark:text-white ${
              variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
            }`}
          >
            {label}
          </label>
        )}
        <input
          {...rest}
          {...field}
          disabled={disabled}
          type={type}
          id={inputId}
          placeholder={placeholder}
          value={field.value ?? value ?? ""}
          onChange={field.onChange || onChange}
          className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : inputState === "error"
              ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : inputState === "success"
              ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : "border-gray-200 dark:!border-white/10 dark:text-white"
          } ${className}`}
        />
        {error?.message && <p className="mt-1 text-sm text-red-600">{error.message}</p>}
      </div>
    );
  };

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => renderInput({ field, error: fieldState.error })}
      />
    );
  }

  return renderInput();
}

export default InputField;
